import { IPagingData, emptyPagedCollection, WccDto, FileWccInfoDto } from '@sr/dto';
import { extractNestJsErrorMessage, REFETCH_TIME_SPAN } from 'shared/api/rtk-query';
import { IRemotePagedCollection } from 'utils/remote-paged-collection.hook';
import { wccExportApi } from '../api';

export const useWccListToExport = (paging: IPagingData, filter?: string) => {
  const { data, error, isLoading, refetch } = wccExportApi.useGetWccExportListQuery(
    { paging, filter }, 
    { 
      refetchOnMountOrArgChange: REFETCH_TIME_SPAN,
    }
  );

  return {
    collection: data || emptyPagedCollection,
    error: extractNestJsErrorMessage(error),
    isLoading: isLoading,
    refetch
  } as IRemotePagedCollection<WccDto> & { refetch: () => void };
};

export const useFileWccList = (pagination: IPagingData, filter?: URLSearchParams,) => {
  const { data, isLoading, error } = wccExportApi.useGetFilesWccListQuery(
    { paging: pagination, filter: filter?.toString() || '' },
    { refetchOnMountOrArgChange: true });
  const result: IRemotePagedCollection<FileWccInfoDto> = {
    collection: data || emptyPagedCollection,
    error: extractNestJsErrorMessage(error),
    isLoading: isLoading,
  };

  return result;
};